<template>
    <ac-modal :title="'Plan Details - '+currentPlan.planName" ref="modal" :size-class="modalSize">
        <div class="row" v-if="widgetReady">
            <div class="col-md-4">
                <h5 v-if="currentPlan.otherServices">
                    Other Services: <p v-html="currentPlan.otherServices"></p>
                </h5>
            </div>
            <div :class="settingsClass" style="overflow-x: hidden">
                <plan-settings :current-plan="currentPlan">

                </plan-settings>
            </div>
        </div>
    </ac-modal>
</template>

<script>
    import {api} from "../../../global/framework/api.js";
    import PlanSettings from "./PlanSettings.vue";
    import {mapGetters} from 'vuex';

    export default {
        name: "PlanDetailsModal",
        components: {PlanSettings},
        data() {
            return {
                widgetReady: false,
                currentPlan: {}
            }
        },
        methods: {
            async showModal(planId) {
                this.currentPlan = await api.getData('Shared', planId, 'GetCurrentPlanSettingsView');
                this.widgetReady = true;
                this.$refs.modal.open();
            }
        },
        computed: {
            ...mapGetters({showPricing: 'globalSettings/showPricing'}),
            modalSize() {
                return this.hasValue(this.currentPlan.openTemplate) ? 'modal-lg' : 'modal-md';
            },
            settingsClass() {
                return this.hasValue(this.currentPlan.openTemplate) ? ['col-md-12', 'open-template-settings'] : ['col-md-8'];
            }
        }
    }
</script>

<style scoped>
    .open-template-settings {
        padding: 10px;
    }
</style>